exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dates[data-v-4b815f46] {\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.buttons[data-v-4b815f46] {\n  justify-content: space-between;\n}\n.accordion .cof-customer-box[data-v-4b815f46] {\n  position: relative;\n  height: 51px;\n  overflow: hidden;\n  background: #f8f9fb;\n  border-radius: 16px;\n}\n.accordion .cof-box-active[data-v-4b815f46] {\n  height: auto;\n}\n.detail-row td[data-v-4b815f46] {\n  background: #e7e8ea !important;\n}", ""]);

// exports
